
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  props: {
    /** 选项 */
    options: { type: Array as PropType<string[]>, required: true },
    /** 默认选中项 */
    default: { type: String, default: undefined },
    /** 是否自动获得焦点 */
    autofocus: { type: Boolean, default: false },
    /** 是否禁用 */
    disabled: { type: Boolean, default: false },
    /** 下方提示文本 */
    hint: { type: String, default: undefined },
    /** 提示文本是否不隐藏 */
    persistentHint: { type: Boolean, default: false },
    /** 字段名 */
    label: { type: String, default: undefined },
    /** 占位文本 */
    placeholder: { type: String, default: undefined },
    modelValue: { type: String, default: undefined },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      isFocused: false,
    };
  },
  computed: {
    /** 标签是否悬浮在左上角 */
    shouldLabelFloating(): boolean {
      return this.label !== undefined && (this.isFocused || Boolean(this.modelValue));
    },
    /** hint 是否显示 */
    isHintVisible(): boolean {
      return this.hint !== undefined && (this.isFocused || this.persistentHint);
    },
  },
  mounted() {
    // 若有默认值则设默认值
    if (this.default !== undefined && this.options.includes(this.default)) {
      this.changeValue(this.default);
    }
  },
  methods: {
    changeValue(val: string) {
      this.$emit('update:modelValue', val);
    },
    handleVisibleChange(visible: boolean) {
      // 点击外部使弹框消失时，触发失焦
      if (!visible) {
        this.isFocused = false;
      }
    },
    handleClickTextField() {
      if (this.disabled) {
        return;
      }
      (this.$refs.input as HTMLInputElement).focus();
    },
    handleInputFocused() {
      this.isFocused = true;
    },
    handleInputBlured() {
      this.isFocused = false;
    },
  },
});
